import React, { useEffect } from 'react'
import { IoIosArrowRoundBack } from 'react-icons/io';
import { Link } from 'react-router-dom';

const Notification = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <>
            <div className='container-fluid'>
                <div className='row' style={{ backgroundColor: "#F8F9FA" }}>
                    <div className="col-md-1"></div>
                    <div className="col-md-5 mt-5 p-3" style={{ display: "flex", flexDirection: 'column', gap: "10px" }}>
                        <h2>Preparing For MCA Entrance</h2>
                        <p>NIMCET, MCA JNU, MCA BHU, MAH CET MCA, MCA UPSEE, Jamia Millia Islamia, TANCET, MCA DU</p>
                        <h5>You are at the right platform.</h5>
                        <div><Link to="/signin"><button className='exercise_login_btn'>Login</button></Link>
                            <button className='exercise_login_btn'>Create a new account</button></div>
                    </div>
                    <div className="col-md-6">
                        <div className='design_view'>
                            <h3>NIMCET Test Series</h3>
                            <p>Get access to all premium mock papers (Topic wise + Subject wise + Full length mock Papers)
                                <br /><br />
                                Complete Solution, Detailed Result Analysis, All India Rank, Multiple Attempts, WhatsApp Support</p><br />
                            <button className='exercise_login_btn'>Join Now</button>
                        </div>
                    </div>
                </div>
            </div><br />
            <div className="container">
                <div className='row quiz_list p-5'>
                    <div className="row"><Link to="/ExamView"><IoIosArrowRoundBack className='back_arrow'/></Link></div><br /><br />
                    <div className='text-center'>  <h3>Exam Details</h3></div>

                    The NIMCET (National Institute of Technology MCA Common Entrance Test) is a national-level entrance exam conducted for admission to Master of Computer Applications (MCA) programs at various National Institutes of Technology (NITs) across India. Below are the key details of the exam:<br />


                </div>
            </div>
        </>
    )
}

export default Notification